import { illustrationResolver } from "resolvers";

const illustrationsResolver = (illustrations) =>
  illustrations.map(illustrationResolver);

export default illustrationsResolver;
